(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('HistoryService', HistoryService);

  HistoryService.$inject = ['$resource'];

  function HistoryService ($resource) {
    return $resource(apiUrl + '/history/:id', { id: '@id' }, {
      paged: { url: apiUrl + '/history', method: 'GET', params: {}, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      restoreContact: { url: apiUrl + '/restore-history/:id', method: 'POST', params: {}, isArray: false },
      download: { url: apiUrl + '/history/download/:id', method: 'GET', params: {}, isArray: true },
      customerRecurrence: { url: apiUrl + '/history/customer-recurrence/:contact_id', method: 'POST', params: {}, isArray: false },
      findByContactId: { url: apiUrl + '/history/chat-history/:contact_id', method: 'GET', params: {}, isArray: false },
      getAiClassification: { url: apiUrl + '/history/get-ai-classification/:contact_id', method: 'GET', params: {}, isArray: false },
      setAiClassification: { url: apiUrl + '/history/set-ai-classification', method: 'POST', params: {}, isArray: false },
      attachment: { url: apiUrl + '/history/attachment/:id', method: 'GET', params: {}, isArray: false },
      generateSignedCCB: { url: apiUrl + '/history/generate-signed-ccb', method: 'POST', params: {}, isArray: false },
      getCountries: { url: apiUrl + '/country/get-countries', method: 'GET', params: {}, isArray: false },
      getCompanyLocalization: { url: apiUrl + '/company-metadata-key/localization', method: 'GET', params: {}, isArray: false },
    });
  }
})();
